import {
  deleteMeAPI,
  DELETEMeReqBody,
  GETAdditionalUserInformation,
  getAdditionalUserInformationAPI,
  GETAuthorProfile,
  getAuthorProfileAPI,
  GETAuthorProfileMymes,
  getAuthorProfileMymesAPI,
  GETUserAvatar,
  getUserAvatarAPI,
  patchEmailActivationAPI,
  PATCHEmailActivationReqBody,
  patchFCMTokenAPI,
  PATCHFCMTokenReqBody,
  postEmailChangeAPI,
  POSTEmailChangeReqBody,
  POSTUploadAuthorBannerResponse,
  postUserProfileAPI,
  POSTUserProfileReqBody,
  uploadDesktopAuthorBannerAPI,
  uploadMobileAuthorBannerAPI,
  uploadUserAvatarAPI
} from '@myme/api';
import {
  DefaultUploadFileReqBody,
  Pagination,
  sendRequest,
  transformPaginationToSearchParams,
  UUID
} from '@myme/utils';

const getAuthorIdRecord = (authorId: UUID) => ({
  key: 'authorId',
  value: authorId
});

/* **** POST **** /user-context/profile-image */
export const uploadUserAvatar = async (reqBody: FormData) =>
  sendRequest<POSTUploadAuthorBannerResponse, DefaultUploadFileReqBody>(uploadUserAvatarAPI, {
    reqBody: reqBody as unknown as DefaultUploadFileReqBody
  });

/* **** POST **** /user-context/banner-desktop */
export const uploadAuthorDesktopBanner = async (reqBody: FormData) =>
  sendRequest<POSTUploadAuthorBannerResponse, DefaultUploadFileReqBody>(uploadDesktopAuthorBannerAPI, {
    reqBody: reqBody as unknown as DefaultUploadFileReqBody
  });

/* **** POST **** /user-context/banner-mobile */
export const uploadAuthorMobileBanner = async (reqBody: FormData) =>
  sendRequest<POSTUploadAuthorBannerResponse, DefaultUploadFileReqBody>(uploadMobileAuthorBannerAPI, {
    reqBody: reqBody as unknown as DefaultUploadFileReqBody
  });

/* **** GET **** /user-context/me */
export const getAdditionalUserInformation = async () =>
  sendRequest<GETAdditionalUserInformation, null>(getAdditionalUserInformationAPI);

/* **** GET **** /user-context/profile-image */
export const getUserAvatar = async () => sendRequest<GETUserAvatar, null>(getUserAvatarAPI);

/* **** GET **** /user-context/author/:authorId */
export const getAuthorProfile = async (authorId: UUID) =>
  sendRequest<GETAuthorProfile, null>(getAuthorProfileAPI, {
    args: [getAuthorIdRecord(authorId)]
  });

/* **** GET **** /myme/author/:authorId/created */
export const getAuthorProfileMymes = async (authorId: UUID, pagination: Pagination) =>
  sendRequest<GETAuthorProfileMymes, null>(getAuthorProfileMymesAPI, {
    args: [getAuthorIdRecord(authorId)],
    queryStringParams: transformPaginationToSearchParams(pagination)
  });

/* **** POST **** /user-context/ */
export const postUserProfile = (reqBody: POSTUserProfileReqBody) =>
  sendRequest<null, POSTUserProfileReqBody>(postUserProfileAPI, { reqBody });

/* **** DELETE **** /user-context/me */
export const deleteMe = (reqBody: DELETEMeReqBody) =>
  sendRequest<null, { data: DELETEMeReqBody }>(deleteMeAPI, { reqBody: { data: reqBody } });

/* **** POST **** /user-context/change-email */
export const changeEmail = (reqBody: POSTEmailChangeReqBody) =>
  sendRequest<null, POSTEmailChangeReqBody>(postEmailChangeAPI, { reqBody });

/* **** PATCH **** /user-context/activate-email */
export const activateEmail = (reqBody: PATCHEmailActivationReqBody) =>
  sendRequest<null, PATCHEmailActivationReqBody>(patchEmailActivationAPI, { reqBody });

/* **** PATCH **** /user-context/update-fcm-token */
export const addFCMToken = (reqBody: PATCHFCMTokenReqBody) =>
  sendRequest<null, PATCHFCMTokenReqBody>(patchFCMTokenAPI, { reqBody });
